import { Specialty, TimeSlot } from 'store/booking/types';
import { Location } from 'store/findProvider/types';

export type AppointmentType = 'In Clinic' | 'Video' | null;

export enum ObGynVisitType {
  prenatal = 'Prenatal visit',
  annual = 'Annual Breast/Pelvic Exam'
}

export interface AppointmentLocation {
  locationId: string;
  locationName: string;
  organizationId?: string;
  locationDisplay?: string;
  phoneDisplay: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  postalCode: string;
  longitude: string;
  latitude: string;
  slots: TimeSlot[] | Slots[];
}

export type AppointmentLocationDisplay = Location & {
  name: string;
};

export interface StateLicense {
  stateCode: string;
}

export interface VisitType {
  id: string;
  synonymId: string;
  synonymDisplay?: string;
  name: string;
  label: string;
  visitTypeId: string;
  visitTypeCode: string;
  commentRequired: boolean;
  specialty: Specialty;
  bookingLocationSet: AppointmentLocation[];
  specialtyDisplaySet: string[];
  locations: AppointmentLocation[];
  appointmentType: AppointmentType;
  appointmentNameInCerner: string;
}

export interface VisitTypeNpv {
  typeId: string;
  synonymId: string;
  synonymDisplay: string;
  visitType: string;
  appointmentType: AppointmentType;
  slots: Slots[];
  stateLicenseList?: StateLicense[];
  bookingLocationId: string;
}

export interface GroupedVisitType {
  id?: string;
  synonymId: string;
  visitTypeId: string;
  name: string;
  description: string;
  visitTypes: VisitType[] | VisitTypeNpv[];
  appointmentTypes: AppointmentType[];
  insuranceTypes?: string[];
  stateLicenseList?: StateLicense[];
}

export interface GroupedVisitTypeError {
  errorCode: string;
  errorDescription: string;
  errors: string[];
  requestId: string;
  statusCode: number;
  url: string;
}

export interface Slots {
  id: string;
  scheduleReference: string;
  type: string;
  datetime: string;
  start: string;
  end: string;
}
